<template>
  <app-main-layout>
    <!--  -->
    <!-- Main Left Menu  -->
    <template v-slot:left>
      <app-left-nav />
    </template>
    <!--  -->
    <!-- Main Top Menu -->
    <template v-slot:top>
      <app-top-nav padded>
        <template v-slot:left>
          <el-page-header
            icon="el-icon-left"
            title="Opportunities"
            :content="count !== undefined ? `${count} Opportunities` : ''"
          />
        </template>
        <template v-slot:center>
          <span>
            <!-- Search -->
          </span>
        </template>
        <template v-slot:right>
          <!-- Other buttons -->
        </template>
      </app-top-nav>
    </template>
    <!--  -->
    <!-- Main Content -->
    <template v-slot:main>
      <!--  -->
      <!-- Charts -->
      <!--  -->
      <!-- Loaded Opportunities -->
      <div>
        <OpportunitiesList :loading="loading"  :opportunities="opportunities"></OpportunitiesList>
      </div>
    </template>
    <!--  -->
    <!--  -->
    <!--  -->
  </app-main-layout>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import OpportunitiesList from "./components/opportunities-list.component.vue";

@Options({
  components: { OpportunitiesList },
})
export default class extends Vue {
  /**
   * @returns opportunities
   */
  get opportunities() {
    return this.$store.state.opportunities.opportunities;
  }

  /**
   * @returns opportunities
   */
  get loading() {
    return this.$store.state.opportunities.loading;
  }

  get count() {
    return this.$store.state.opportunities.count;
  }

  mounted() {
    this.$store.dispatch("opportunities/fetch");
  }
}
</script>

<style lang="scss"></style>
